import { FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface OwnerIdentityFieldValues {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export const OwnerIdentityFields = () => {
  const { t } = useTranslation();
  const { register, formState } = useFormContext<OwnerIdentityFieldValues>();
  const errors = formState.errors;

  return (
    <>
      <FormControl isInvalid={errors.firstName !== undefined} mt="5px">
        <FormLabel htmlFor="firstName">{t("First name")}</FormLabel>
        <Input
          id="firstName"
          autoComplete="given-name"
          type="text"
          {...register("firstName", {
            required: t("Please provide your first name.") ?? "",
            minLength: { value: 2, message: t("Must be at least 2 characters long.") },
          })}
        />
        <FormErrorMessage>{errors.firstName?.message}</FormErrorMessage>
      </FormControl>
      <FormControl isInvalid={errors.lastName !== undefined} mt="5px">
        <FormLabel htmlFor="lastName">{t("Last name")}</FormLabel>
        <Input
          id="lastName"
          autoComplete="family-name"
          type="text"
          {...register("lastName", {
            required: t("Please provide your last name.") ?? "",
            minLength: { value: 2, message: t("Must be at least 2 characters long.") },
          })}
        />
        <FormErrorMessage>{errors.lastName?.message}</FormErrorMessage>
      </FormControl>
      <FormControl isInvalid={errors.email !== undefined} mt="5px">
        <FormLabel htmlFor="email">{t("Email")}</FormLabel>
        <Input
          id="email"
          autoComplete="email"
          type="email"
          {...register("email", {
            required: t("Please provide your email.") ?? "",
            minLength: { value: 2, message: t("Must be at least 2 characters long.") },
          })}
        />
        <FormErrorMessage>{errors.email?.message}</FormErrorMessage>
      </FormControl>
      <FormControl isInvalid={errors.password !== undefined} mt="5px">
        <FormLabel htmlFor="password">{t("Password")}</FormLabel>
        <Input
          id="password"
          autoComplete="new-password"
          type="password"
          {...register("password", {
            required: t("Please provide your desired password.") ?? "",
            minLength: { value: 8, message: t("Your password must be at least 8 characters long.") },
          })}
        />
        <FormErrorMessage>{errors.password?.message}</FormErrorMessage>
      </FormControl>
    </>
  );
};
